window.app.controller('stickyAppCtrl', ['$scope', '$rootScope', function ($scope, $rootScope) {
    $scope.showStickyApp = true;
    $scope.costMin = 50;
    $scope.costMax = 5000;

    $scope.durationMin = 1; 
    $scope.durationMax = 60;

    $scope.costVal = +(sessionStorage.hasOwnProperty('orangeRange') ? sessionStorage.getItem('orangeRange') : 2500);
    $scope.durationVal = +(sessionStorage.hasOwnProperty('blueRange') ? sessionStorage.getItem('blueRange') : 30);

    $scope.checkInputsSize = (newvalue, element, min, max) => {
        newvalue = +newvalue;
        if (newvalue <= min) {
            newvalue = min;
            $(element).val( min );
        }
        else if (newvalue >= max) {
            newvalue = max;
            $(element).val( max );
        } 
        return {
            value: newvalue
        };
    }

    $scope.checkInputsDataType = (value, middleVal) => {
        var newValue;
        if (/\d/.test(value)) {
        newValue = value.match(/\d+/)[0];
        } else {
        newValue = middleVal;
        }
        return newValue;
    }

    $('#costValSt').change(function() {
        let newValue = $scope.checkInputsDataType($(this).val(), 2500);
        let newData = $scope.checkInputsSize(newValue, '#costValSt', $scope.costMin, $scope.costMax);
        newValue = newData.value;
        $scope.costVal = newValue;        
        $(this).val( +newValue );
        // $scope.passAppParams();
    });

    $('#durationValSt').change(function() {
        let newValue = $scope.checkInputsDataType($(this).val(), 30);
        let newData = $scope.checkInputsSize(newValue, '#durationValSt', $scope.durationMin, $scope.durationMax);
        newValue = newData.value;     
        $scope.durationVal = newValue; 
        $(this).val( +newValue );
        // $scope.passAppParams();
    });

    $scope.setCalcData = () => {
        localStorage.setItem('orangeRange', $scope.costVal);
        localStorage.setItem('blueRange', $scope.durationVal);
  
        $scope.redirect('/application');
    }
    
    $scope.closeStickyApp = () => {
        $('.stickyApp').fadeOut("fast");
        $scope.showStickyApp = false;
        $scope.toogleStickyApp();
    }

    $(document).scroll(function() {
        var y = $(this).scrollTop();
        if (y > 550 && $scope.showStickyApp) {
          $('.stickyApp').fadeIn("fast");
        } else {
          $('.stickyApp').fadeOut("fast");
        }
    });

    $scope.toogleStickyApp = () => {
        $rootScope.$broadcast('toogleStickyApp', {
            showStickyApp: $scope.showStickyApp,
        })
    }

    // $scope.passAppParams = () => {
    //     $rootScope.$broadcast('passAppParams', {
    //         costVal: $scope.costVal,
    //         durationVal:  $scope.durationVal
    //     })
    // }

}])


// WEBPACK FOOTER //
// src/js/controllers/singleApplication/stickyAppCtrl.js